module.exports = __webpack_public_path__ + "img/star.e3b0fe67.svg";